import React from 'react'
import { useConnect } from 'sb-redux-hook'
import actions from 'redux/actions'

import { Icon } from 'components/_new/ui'
import { Box, WidthContainer } from 'components/_new/layout'
import Sidebar from 'pages/seo/CommonPage/Sidebar/Sidebar'

import s from './FiltersOverlay.scss'


const close = () => actions.view.smartSearchPage.closeFiltersOverlay()


const FiltersOverlay = () => {
  const { isVisible } = useConnect({
    isVisible: 'view.smartSearchPage.isFiltersOverlayVisible',
  })

  return isVisible && (
    <div className={s.filtersOverlay}>
      <div className={s.header}>
        <button className={s.closeButton} onClick={close} type="button">
          <Icon name="closeLight" />
        </button>
      </div>
      <div className={s.content}>
        <WidthContainer className={s.container}>
          <Box pt={16}>
            <Sidebar fullWidth />
          </Box>
        </WidthContainer>
      </div>
    </div>
  )
}


export default FiltersOverlay
